import { render } from "./CreateZone.vue?vue&type=template&id=677b7799&scoped=true"
import script from "./CreateZone.vue?vue&type=script&lang=js"
export * from "./CreateZone.vue?vue&type=script&lang=js"

import "./CreateZone.vue?vue&type=style&index=0&id=677b7799&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-677b7799"

export default script